import ConfirmationPage from './ConfirmationPage';

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/index.js